import React, {useEffect, useState} from "react";
import { addTagsToTask } from "../../asyncActions/TagsToTaskActions/addTagsToTask";
import { useDispatch } from 'react-redux/es/exports';

export default function MainTagList({updateTagList, taskId, tags, tagList, isMarked, coloredPart, isHideCheckedItems, removeTagFromTagList, showCheckbox=true, keys, inList, ...props}) {
    const dispatch = useDispatch();

    const [checkedValue, setCheckedValue] = useState(false);
    

    const objTagsToTask = {
        taskId: taskId,
        tagId: tags.id
    }
    
    useEffect(() => {
        if(inList) {
            setCheckedValue(true)
        } else {
            setCheckedValue(false)
        }
    }, [inList])

    
    function addTagToTask() {
        dispatch(addTagsToTask(objTagsToTask))
    }
    
    function addTagsToAddTaskFunction(e) {
        updateTagList(e, {
            tagId: tags.id,
            tagName: tags.tagName
        })
        setCheckedValue(true)
        e.preventDefault()
    }

    const isUnchecked = (e) => {
        removeTagFromTagList(tags.id)
        setCheckedValue(false)
        e.preventDefault()
    }

    // const getHighlightedText = (text, match) => {
    //     const parts = text.split(new RegExp(`(${match})`, 'gi'));
    //     return parts.map((part, index) =>
    //       part.toLowerCase() === match.toLowerCase() ? (
    //         <p key={index} style={{ color: '#5932EA', fontWeight: '600' }}>{part}</p>
    //       ) : (
    //         part
    //       )
    //     );
    // };
      
    return (
        <>  
            <li data-list={inList}  data-tagkey={keys} className={`tags__item ${isMarked ? 'active' : {}}`} style={isHideCheckedItems && inList ? {display: 'none'} : {display: 'block'}} onClick={(e) => checkedValue ? isUnchecked(e) : addTagsToAddTaskFunction(e)}>
                    <div className="tags-box">
                        <p style={{display: 'flex'}} className="tags__title">{tags.tagName}</p>
                        {/* <p className="tags__title"></p> */}
                        {
                            showCheckbox &&
                            <label style={{display: "flex"}}>
                            <input type="checkbox"  className="tags__checkbox" checked={checkedValue} 
                                onChange={() => addTagToTask()} onClick={(e) => checkedValue ? isUnchecked() : addTagsToAddTaskFunction()}/>
                                <span></span>
                            </label>
                        }
                    </div>
            </li>
        </>
    )
}